module.exports = __webpack_public_path__ + "static/bootstrap-card-tabs-a3e3f9fb0f02f5f09132a64225680c97.png";